@if (loading) {
  <img class="d-inline-block mb-1" src="assets/img/loading-icon.svg" [height]="size" [width]="size"/>
} @else {
  <ng-content></ng-content>
}
